export enum BookingStatus {
  BOOKED_SUCCESSFULLY = 'BOOKED_SUCCESSFULLY',
  CANCELED = 'CANCELED'
}
